import { inject, Injectable, OnDestroy } from '@angular/core';
import { Kpi } from 'app/modules/admin/common/kpi-widget/kpi';
import { DeviceKpisApi } from 'app/modules/admin/devices/device-kpis/device-kpis.api';
import { map, Observable, of, Subject, takeUntil } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DeviceKpisService implements OnDestroy {
    private _deviceKpisApi = inject(DeviceKpisApi);
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Get all device KPIs for the given company.
     */
    getAllDeviceKpis(companyId: number): Observable<Kpi[]> {

        if (!companyId) {
            return of([]);
        }

        return this._deviceKpisApi.getAllDeviceKpis(companyId).pipe(takeUntil(this._unsubscribeAll),
            map(response => response.map(kpi => {
                // TODO Rename directly in the API and remove switch, or better implement based on an ID / TYPE / KEY.
                let title: string;

                switch (kpi.title) {
                    case 'Online':
                        title = 'Connected devices';
                        break;
                    case 'With warnings':
                        title = 'Devices with warnings';
                        break;
                    case 'With errors':
                        title = 'Devices with errors';
                        break;
                    default:
                        title = kpi.title;
                }

                return new Kpi(title, kpi.value, kpi.total)
            }))
        );
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
